import React, { useState, useEffect, useCallback } from 'react';
import { FiSearch } from 'react-icons/fi';
import { api } from '../api';

const ACTION_STYLE = {
  create: { background: '#E9F3EC', color: '#3B7A4E' },
  update: { background: '#EAF1FB', color: '#2C5F8A' },
  delete: { background: '#FBEEEA', color: '#B4432E' },
  verify: { background: '#E9F3EC', color: '#3B7A4E' },
  reject: { background: '#FBEEEA', color: '#B4432E' },
  login:  { background: '#F1F0EC', color: '#6B6560' },
};

export default function AuditLog() {
  const [data, setData] = useState(null);
  const [entity, setEntity] = useState('');
  const [action, setAction] = useState('');
  const [q, setQ] = useState('');
  const [toast, setToast] = useState('');

  const load = useCallback(async () => {
    const p = new URLSearchParams();
    if (entity) p.set('entity', entity);
    if (action) p.set('action', action);
    if (q) p.set('q', q);
    try { setData(await api('/audit' + (p.toString() ? '?' + p : ''))); }
    catch (e) { setToast(e.message); }
  }, [entity, action, q]);
  useEffect(() => { load(); }, [load]);

  function fmt(ts) {
    const d = new Date(ts);
    return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  if (!data) return <div className="o-screen"><div className="empty">{toast || 'Loading…'}</div></div>;

  return (
    <div className="o-screen">
      <div className="mod-head">
        <div className="titles">
          <div className="page-eyebrow">Configuration</div>
          <h1>Audit Log</h1>
          <div className="count">{data.rows.length} recent events</div>
        </div>
      </div>

      <div className="filter-bar" style={{ display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', flex: 1, minWidth: 220 }}>
          <FiSearch style={{ position: 'absolute', left: 12, top: 11, color: 'var(--muted,#6B7280)' }} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search summary or user…"
            style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1px solid var(--o-line,#DDE2EA)', borderRadius: 9, fontSize: 14 }} />
        </div>
        <select className="status-select" value={entity} onChange={(e) => setEntity(e.target.value)}>
          <option value="">All entities</option>
          {data.entities.map((x) => <option key={x} value={x}>{x}</option>)}
        </select>
        <select className="status-select" value={action} onChange={(e) => setAction(e.target.value)}>
          <option value="">All actions</option>
          {data.actions.map((x) => <option key={x} value={x}>{x}</option>)}
        </select>
      </div>

      <div className="table-card">
        {data.rows.length === 0 ? <div className="empty"><h3>No events</h3><p>Actions across the system will appear here.</p></div> :
          <table className="data">
            <thead><tr><th>When</th><th>User</th><th>Action</th><th>Entity</th><th>Details</th></tr></thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.id}>
                  <td style={{ whiteSpace: 'nowrap', color: 'var(--muted,#6B7280)', fontSize: 13 }}>{fmt(r.created_at)}</td>
                  <td style={{ fontWeight: 600 }}>{r.user_name || <span style={{ color: 'var(--muted,#6B7280)' }}>system</span>}</td>
                  <td><span className="pill" style={ACTION_STYLE[r.action] || { background: '#F1F0EC', color: '#6B6560' }}>{r.action}</span></td>
                  <td style={{ color: 'var(--muted,#6B7280)' }}>{r.entity}{r.entity_id ? ` #${r.entity_id}` : ''}</td>
                  <td>{r.summary || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>}
      </div>
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}
